import React,{useEffect,useState} from 'react'
import Carousel from "react-spring-3d-carousel";
import uuidv4 from "uuid";
import { config } from "react-spring";
import '../styles/partners.scss'
import data from '../data/partners.json'


export default function Partner() {

  const [goToSlide,setSlide] = useState(0);
  const offsetRadius =2;
  const confiig=config.gentle;
  const slides = [
    {
      key: uuidv4(),
      content: <div className="white-container d-flex justify-content-center  align-items-center"><img src="/Entain.png"  width="171px" height="157px" alt="1" /></div>
    },
    {
      key: uuidv4(),
      content:  <div className="white-container d-flex justify-content-center  align-items-center"><img src="/united-commissions.png" width="171px" height="157px" alt="2" /></div>
    },
   
    {
        key: uuidv4(),
        content:  <div className="white-container d-flex justify-content-center  align-items-center"><img src="/genesis.png" alt="3" width="171px" height="157px" /></div>
      },
      {
        key: uuidv4(),
        content:  <div className="white-container d-flex justify-content-center  align-items-center"><img src="/rank-affiliates.png" width="171px" height="157px" alt="3" /></div>
      },
 
   
  ].map((slide, index) => {
    return { ...slide, onClick: () => setSlide(index) };
  });

  useEffect(() => {
    
    
    var counter = goToSlide;
    setInterval(() => {
     
      setSlide(counter)
       counter++;
       if(counter > 3){
        counter = 0;
      }
    }, 5000);
   
  
  },[]); 
  return (
    <div id="partner" >
        <div className="container pt-5">
          <div className="d-flex justify-content-center align-items-center">
                    <img src="/left_leaf.png" alt="left" />
                    <div className="partner-text">Partners</div>
                    <img src="/right_leaf.png" alt="right"/>
          </div>
          <div className="text-center partner-heading">Our Affiliations</div>

        </div>
        
        <div className="carousel-width">
            <Carousel slides={slides}
              goToSlide={goToSlide}
              offsetRadius={offsetRadius}
              animationConfig={confiig}
              >
            </Carousel>
        </div>
        <div className="d-flex align-items-center flex-column pb-5 ">
                  <div className="partner-title">{data[goToSlide].title}</div>
                  <div className="partner-body mt-3">
                   {data[goToSlide].body}
                  </div>
                  <div className="mt-3 mb-3 learn-text"><a rel="noopener noreferrer" target="_blank" href={data[goToSlide].href}>Learn more <img width={25} height={25} alt="arrow_right" className="ms-2" src="/arrow_right.png"/></a></div>

        </div>
       

    </div>
        
    )
}
